module.exports = __webpack_public_path__ + "static/img/training1.5294e38d.png";